'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';

const docsSections = [
  {
    title: 'GETTING STARTED',
    icon: '📚',
    items: [
      { label: 'Introduction', href: '/documentation' },
      { label: 'Installation', href: '/documentation/installation' },
      { label: 'Project Setup', href: '/documentation/project-setup' },
      { label: 'Project Settings JSON', href: '/help/project-setting-json-schema' },
    ],
  },
  {
    title: 'EDITOR FEATURES',
    icon: '⚡',
    items: [
      { label: 'Real-time Collaboration', href: '/documentation/collaboration' },
      { label: 'Auto-completion', href: '/documentation/autocompletion' },
      { label: 'Keyboard Shortcuts', href: '/documentation/shortcuts' },
    ],
  },
  {
    title: 'LATEX GUIDE',
    icon: '📖',
    items: [
      { label: 'Basic Syntax', href: '/documentation/syntax' },
      { label: 'Mathematics', href: '/documentation/mathematics' },
      { label: 'Tables & Figures', href: '/documentation/tables' },
      { label: 'Bibliography', href: '/documentation/bibliography' },
    ],
  },
  {
    title: 'ADVANCED',
    icon: '⚙️',
    items: [
      { label: 'Package Management', href: '/documentation/packages' },
      { label: 'Custom Templates', href: '/documentation/templates' },
      { label: 'API Reference', href: '/documentation/api' },
    ],
  },
];

export function LandingDocsSidebar() {
  const pathname = usePathname();

  return (
    <aside className="w-full md:w-64 border-r border-border bg-sidebar md:sticky md:top-16 md:h-[calc(100vh-64px)]">
      <nav className="docs-scroll md:h-full md:overflow-y-auto p-4 pb-8 mr-1 space-y-6">
        {docsSections.map((section) => (
          <div key={section.title}>
            <div className="flex items-center gap-2 text-xs font-semibold text-primary mb-3">
              <span>{section.icon}</span>
              <span>{section.title}</span>
            </div>
            <div className="space-y-2">
              {section.items.map((item) => (
                <Link
                  key={item.href}
                  href={item.href}
                  className={`block px-3 py-2 rounded-md text-sm transition-colors ${
                    pathname === item.href
                      ? 'bg-primary text-primary-foreground font-medium'
                      : 'text-sidebar-foreground hover:bg-sidebar-accent'
                  }`}
                >
                  {item.label}
                </Link>
              ))}
            </div>
          </div>
        ))}
      </nav>
    </aside>
  );
}
